import camelCase from 'lodash/camelCase';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { versionDetailsRelayResourceCustom } from '@jira/router-resources__software-versions/src/versionDetailsRelayResourceCustom.tsx';
import { softwareVersionDetailRoute } from '@jira/router-routes__software-versions-routes/src/softwareVersionDetailRoute.tsx';
import { VersionDetailSkeleton } from '@jira/platform__skeletons/src/ui/versions/VersionDetailSkeleton.tsx';
import { softwareProjectLayoutNoOnboarding } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import { LazyVersionDetail, VersionDetailPage } from './ui/version-detail/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const softwareVersionDetailRouteEntry: Route = createEntry(
	softwareVersionDetailRoute,
	() => ({
		group: 'software',
		ufoName: 'software.version-details-page',
		// eslint-disable-next-line no-restricted-syntax
		component: VersionDetailPage,
		skeleton: VersionDetailSkeleton,
		canTransitionIn: () => true,
		layout: softwareProjectLayoutNoOnboarding,

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [
			...getNavigationResources(),
			// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
			// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
			incidentExperimentTraitResource,
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			// end of resources expanded from getNavigationSidebarProjectResource
			versionDetailsRelayResourceCustom,
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyVersionDetail],

		meta: {
			reporting: {
				id: 'software-version-detail',
				packageName: camelCase('software-version-detail'),
				teamName: 'a4t-pandora',
			},
		},

		supportsPreviewPanel: true,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
